import { connectSearchBox } from 'react-instantsearch-dom';
import { SearchBox } from 'components/content/SearchBox';
var SearchBoxFilter = connectSearchBox(SearchBox);
export default SearchBoxFilter;